module.exports = __webpack_public_path__ + "img/youtube.5799f4f5.svg";